import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import * as messageConstants from '../../../shared/messages';

class GenerateClientSecretModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onConfirm: PropTypes.func,
  }

  // Track whether confirm has already been clicked to avoid duplicate requests
  state = {
    isSubmitting: false,
  };

  componentDidUpdate(prevProps) {
    // Reset submitting state when the modal transitions from open to closed.
    if (prevProps.show && !this.props.show) {
      this.setState({ isSubmitting: false });
    }
  }

  handleConfirmClick = () => {
    const { isSubmitting } = this.state;
    const { onConfirm } = this.props;
    // Prevent multiple submissions
    if (isSubmitting) {
      return;
    }
    this.setState({ isSubmitting: true });
    onConfirm();
  };

  render() {
    const { show, onHide } = this.props;
    const { isSubmitting } = this.state;
    return (
      <div>
        <Modal
          show={show}
          onHide={onHide}
          container={this}
          dialogClassName="generate-client-secret-modal"
        >
          <Modal.Header
              className="generate-client-secret-modal-header"
          >
            <Modal.Title
                className="line-height-for-modal-title"
            >
              <span className="generate-client-secret-modal-header-text">
                {messageConstants.OIDC_GENERATE_NEW_CLIENT_SECRET}
              </span>
              <button
                className="entity-id-modal-close"
                type="button"
                aria-label="Close modal"
                onClick={onHide}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
              className="generate-client-secret-modal-body"
              >
            <div className="modal-text-item-top">
              {messageConstants.OIDC_CLIENT_SECRET_BODY_ROW_ONE_TEXT_ONE}
              <b>{messageConstants.OIDC_CLIENT_SECRET_BODY_ROW_ONE_TEXT_TWO}</b>
              {messageConstants.OIDC_CLIENT_SECRET_BODY_ROW_ONE_TEXT_THREE}
            </div>
            <div className="modal-text-item-bottom">
                {messageConstants.OIDC_CLIENT_SECRET_BODY_ROW_TWO_TEXT_ONE}
              <b>{messageConstants.OIDC_CLIENT_SECRET_BODY_ROW_TWO_TEXT_TWO}</b>
              {messageConstants.OIDC_CLIENT_SECRET_BODY_ROW_TWO_TEXT_THREE}
            </div>
          </Modal.Body>
          <Modal.Footer
              className="generate-client-secret-modal-footer"
          >
            <button
              type="button"
              className="btn btn-md cancel-generate-secret-button"
              onClick={onHide}
            >
              {messageConstants.CANCEL}
            </button>
            <button
              type="button"
              className="btn btn-md btn-primary confirm-generate-secret-button"
              onClick={this.handleConfirmClick}
              disabled={isSubmitting}
            >
              {messageConstants.OIDC_GENERATE_NEW_CLIENT_SECRET}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default GenerateClientSecretModal;
